<div class="row py-3 card-border" [class.odd]="odd">
  <div class="col-6">
    <div class="h5 loading-text-field loading my-2 w-20"></div>
    <div class="loading-text-field loading my-2 w-50"></div>
    <div class="loading-text-field loading my-2 w-50"></div>
    <div class="loading-text-field loading my-2 w-40"></div>
  </div>
</div>
